import { useHits } from 'react-instantsearch';
import { useIntl } from 'react-intl';

import { Container } from '@/components/Container';
import { LegacyButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';
import { useRouter } from '@/hooks/useRouter';
import type { StoreHit } from '@/integrations/algolia/types';
import { commonMessages as boutiqueMessages } from '@/messages/appointment';
import { messages } from '@/views/WatchView/components/AvailabilityRequestModal/messages';

import { BoutiqueCard } from '../BoutiqueCard/index';

import * as S from './Boutiques.styles';

export const Results = () => {
  const { query } = useRouter();
  const { hits } = useHits<StoreHit>();
  const { formatMessage } = useIntl();

  return (
    <Container data-test-id='BoutiquesWrapper' maxWidth='lg'>
      <S.BoutiquesContent data-test-id='BoutiquesContent'>
        <S.BoutiqueListFlex data-test-id='BoutiqueListFlex'>
          {hits?.length !== 0 ? (
            hits.map((boutique, index) => (
              <BoutiqueCard
                key={boutique.objectID}
                boutique={boutique}
                countrySlug={query?.country as string}
                data-test-id={`BoutiqueCard-${index}`}
              />
            ))
          ) : (
            <S.NotFoundStores>
              <S.TextBox>
                <Typography>
                  {formatMessage(boutiqueMessages.noAvailableBoutiques)}
                </Typography>
              </S.TextBox>
              <S.TextBox>
                <Typography>
                  {formatMessage(boutiqueMessages.storeLocatorToBrowse)}
                </Typography>
              </S.TextBox>
              <S.StoreLocator>
                <LegacyButton as='a' href='/stores'>
                  {formatMessage(messages.storeLocator)}
                </LegacyButton>
              </S.StoreLocator>
            </S.NotFoundStores>
          )}
        </S.BoutiqueListFlex>
      </S.BoutiquesContent>
    </Container>
  );
};
